<div class="main-table">
  <div class="main-table-companies" *ngIf="!showEndpoint">
    <ng-container *ngIf="dataCompanies.length > 0; else noDataTable">
      <nz-table
        [ngStyle]="{ height: tableHeight }"
        [nzScroll]="{ y: tableHeight }"
        [nzSize]="'small'"
        [nzFrontPagination]="false"
        (nzPageIndexChange)="onPageIndexChange($event, 'companies')"
        [nzPageSize]="paginationState.per_page"
        [nzPageIndex]="paginationState.current_page"
        [nzTotal]="paginationState.total"
        [nzData]="dataCompanies"
        #wrapper
      >
        <thead>
          <tr>
            <th nzWidth="40px"></th>
            <th nzWidth="90px">OFF/ON</th>
            <th nzWidth="90px">ID</th>
            <th nzWidth="230px" (click)="sort('name')">
              NAME
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortByDSP === 'name'"
              >
                <span
                  class="sort-icon sort-icon-{{
                    mainTableService.sortOrderDSP
                  }}"
                ></span>
              </span>
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortByDSP !== 'name'"
              >
                <span class="sort-icon sort-icon-normal"></span>
              </span>
            </th>
            <th nzWidth="90px" *ngIf="isOptionActive('type', type)">TYPE</th>
            <th nzWidth="200px" *ngIf="isOptionActive('formats', type)">
              AD FORMATS
            </th>
            <th
              nzWidth="140px"
              *ngIf="isOptionActive('limitQPS', type)"
              (click)="sort('limitQPS')"
            >
              LIMIT QPS
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortByDSP === 'limitQPS'"
              >
                <span
                  class="sort-icon sort-icon-{{
                    mainTableService.sortOrderDSP
                  }}"
                ></span>
              </span>
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortByDSP !== 'limitQPS'"
              >
                <span class="sort-icon sort-icon-normal"></span>
              </span>
            </th>
            <th
              nzWidth="140px"
              *ngIf="isOptionActive('realQPS', type)"
              (click)="sort('realQPS')"
            >
              REAL QPS
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortByDSP === 'realQPS'"
              >
                <span
                  class="sort-icon sort-icon-{{
                    mainTableService.sortOrderDSP
                  }}"
                ></span>
              </span>
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortByDSP !== 'realQPS'"
              >
                <span class="sort-icon sort-icon-normal"></span>
              </span>
            </th>
            <th
              nzWidth="110px"
              *ngIf="isOptionActive('bidQPS', type)"
              (click)="sort('bidQPS')"
            >
              BID QPS
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortByDSP === 'bidQPS'"
              >
                <span
                  class="sort-icon sort-icon-{{
                    mainTableService.sortOrderDSP
                  }}"
                ></span>
              </span>
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortByDSP !== 'bidQPS'"
              >
                <span class="sort-icon sort-icon-normal"></span>
              </span>
            </th>
            <th
              nzWidth="140px"
              *ngIf="isOptionActive('daylySpend', type)"
              (click)="sort('daylySpend')"
            >
              DAILY SPEND
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortByDSP === 'daylySpend'"
              >
                <span
                  class="sort-icon sort-icon-{{
                    mainTableService.sortOrderDSP
                  }}"
                ></span>
              </span>
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortByDSP !== 'daylySpend'"
              >
                <span class="sort-icon sort-icon-normal"></span>
              </span>
            </th>
            <th
              nzWidth="180px"
              *ngIf="isOptionActive('yesterdaySpend', type)"
              (click)="sort('yesterdaySpend')"
            >
              YESTERDAY SPEND
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortByDSP === 'yesterdaySpend'"
              >
                <span
                  class="sort-icon sort-icon-{{
                    mainTableService.sortOrderDSP
                  }}"
                ></span>
              </span>
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortByDSP !== 'yesterdaySpend'"
              >
                <span class="sort-icon sort-icon-normal"></span>
              </span>
            </th>
            <th
              nzWidth="180px"
              *ngIf="isOptionActive('dsp_ecpm', type)"
              (click)="sort('dsp_ecpm')"
            >
              Daily CPM
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortByDSP === 'dsp_ecpm'"
              >
                <span
                  class="sort-icon sort-icon-{{
                    mainTableService.sortOrderDSP
                  }}"
                ></span>
              </span>
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortByDSP !== 'dsp_ecpm'"
              >
                <span class="sort-icon sort-icon-normal"></span>
              </span>
            </th>
            <th
              nzWidth="180px"
              *ngIf="isOptionActive('dsp_rcpm', type)"
              (click)="sort('dsp_rcpm')"
            >
              DSP RCPM
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortByDSP === 'dsp_rcpm'"
              >
                <span
                  class="sort-icon sort-icon-{{
                    mainTableService.sortOrderDSP
                  }}"
                ></span>
              </span>
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortByDSP !== 'dsp_rcpm'"
              >
                <span class="sort-icon sort-icon-normal"></span>
              </span>
            </th>
            <th
              nzWidth="200px"
              *ngIf="isOptionActive('total_bid_rate', type)"
              (click)="sort('total_bid_rate')"
            >
              TOTAL BID RATE, %
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortByDSP === 'total_bid_rate'"
              >
                <span
                  class="sort-icon sort-icon-{{
                    mainTableService.sortOrderDSP
                  }}"
                ></span>
              </span>
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortByDSP !== 'total_bid_rate'"
              >
                <span class="sort-icon sort-icon-normal"></span>
              </span>
            </th>
            <th
              nzWidth="150px"
              *ngIf="isOptionActive('win_rate', type)"
              (click)="sort('win_rate')"
            >
              WIN RATE, %
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortByDSP === 'win_rate'"
              >
                <span
                  class="sort-icon sort-icon-{{
                    mainTableService.sortOrderDSP
                  }}"
                ></span>
              </span>
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortByDSP !== 'win_rate'"
              >
                <span class="sort-icon sort-icon-normal"></span>
              </span>
            </th>
            <th
              nzWidth="130px"
              *ngIf="isOptionActive('fill_rate', type)"
              (click)="sort('fill_rate')"
            >
              FILL RATE %
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortByDSP === 'fill_rate'"
              >
                <span
                  class="sort-icon sort-icon-{{
                    mainTableService.sortOrderDSP
                  }}"
                ></span>
              </span>
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortByDSP !== 'fill_rate'"
              >
                <span class="sort-icon sort-icon-normal"></span>
              </span>
            </th>
            <th nzWidth="170px" *ngIf="isOptionActive('spendLimit', type)">
              SPEND LIMIT
            </th>
            <th
              nzWidth="130px"
              *ngIf="isOptionActive('margin', type)"
              (click)="sort('margin')"
            >
              MARGIN
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortByDSP === 'margin'"
              >
                <span
                  class="sort-icon sort-icon-{{
                    mainTableService.sortOrderDSP
                  }}"
                ></span>
              </span>
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortByDSP !== 'margin'"
              >
                <span class="sort-icon sort-icon-normal"></span>
              </span>
            </th>
            <th nzWidth="130px" *ngIf="isOptionActive('region', type)">
              REGION
            </th>
            <th nzWidth="160px" *ngIf="isOptionActive('nurl', type)">NURL</th>
            <th nzWidth="130px" *ngIf="isOptionActive('email', type)">EMAIL</th>
            <th nzWidth="115px" *ngIf="isOptionActive('comments', type)">
              COMMENTS
            </th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let company of dataCompanies; let k = index">
            <tr>
              <td
                nzWidth="40px"
                class="td-toggle"
                (click)="toggleCompanyState(company.id)"
              >
                <div class="arrow" [@toggleArrow]="isClosed(company.id)">
                  <i
                    nz-icon
                    nzType="right"
                    nzTheme="outline"
                    style="color: #002199; font-size: 16px"
                  ></i>
                </div>
              </td>
              <td nzWidth="90px">
                <nz-switch
                  [nzControl]="true"
                  (click)="
                    onChangeActiveCompany($event, company.id, type, company)
                  "
                  [(ngModel)]="company.active"
                  [disabled]="userRole === 'viewer'"
                ></nz-switch>
              </td>
              <td nzWidth="90px"></td>
              <td nzWidth="230px">
                <span
                  nz-tooltip
                  nzTooltipTitle="{{ company.name }}"
                  nzTooltipPlacement="top"
                  >{{ company.name | trunc: [20] }}
                </span>
              </td>
              <td nzWidth="90px" *ngIf="isOptionActive('type', type)">-</td>
              <td nzWidth="200px" *ngIf="isOptionActive('formats', type)"></td>
              <td nzWidth="110px" *ngIf="isOptionActive('limitQPS', type)">
                {{ company.limitQPS }}
              </td>
              <td nzWidth="110px" *ngIf="isOptionActive('realQPS', type)">
                {{ company.realQPS }}
              </td>
              <td nzWidth="110px" *ngIf="isOptionActive('bidQPS', type)">
                {{ company.bidQPS }}
              </td>
              <td nzWidth="140px" *ngIf="isOptionActive('daylySpend', type)">
                {{
                  currencyPipe.transform(
                    +company.daylySpend,
                    "USD",
                    "symbol",
                    ".0-5"
                  )
                }}
              </td>
              <td
                nzWidth="140px"
                *ngIf="isOptionActive('yesterdaySpend', type)"
              >
                {{
                  currencyPipe.transform(
                    +company.yesterdaySpend,
                    "USD",
                    "symbol",
                    ".0-5"
                  )
                }}
              </td>
              <td
                nzWidth="170px"
                *ngIf="isOptionActive('total_bid_rate', type)"
              >
                {{ company.dsp_ecpm }}
              </td>
              <td nzWidth="110px" *ngIf="isOptionActive('dsp_rcpm', type)">
                {{ company.dsp_rcpm }}
              </td>
              <td
                nzWidth="170px"
                *ngIf="isOptionActive('total_bid_rate', type)"
              >
                {{ company.total_bid_rate }}
              </td>
              <td nzWidth="130px" *ngIf="isOptionActive('win_rate', type)">
                {{ company.win_rate }}
              </td>
              <td nzWidth="130px" *ngIf="isOptionActive('fill_rate', type)">
                {{ company.fill_rate }}
              </td>
              <td nzWidth="170px" *ngIf="isOptionActive('spendLimit', type)">
                {{ company.spendLimit }}
              </td>
              <td nzWidth="130px" *ngIf="isOptionActive('margin', type)"></td>
              <td nzWidth="130px" *ngIf="isOptionActive('region', type)">-</td>
              <td nzWidth="160px" *ngIf="isOptionActive('nurl', type)">-</td>
              <td *ngIf="isOptionActive('email', type)"></td>
              <td nzWidth="115px" *ngIf="isOptionActive('comments', type)"></td>
            </tr>
            <tr>
              <td
                class="td-expand"
                *ngIf="isClosed(company.id) === 'visible'"
                [colSpan]="colSpanNumbers"
                style="padding: 0 !important"
              >
                <app-list-endpoints
                  [demand]="demand"
                  [endpoints]="company.dsp_settings"
                  [isClosed]="companiesState[company.id]"
                  [userRole]="userRole"
                  [side]="type"
                  [companyId]="company.id"
                  [allCompanies]="allCompanies"
                  [partnerSettings]="partnerSettings"
                  [filterLists]="filterLists"
                  [statesList]="statesList"
                  [osList]="osList"
                  [rtbVersions]="rtbVersions"
                  [schaninNodeLimitItems]="schaninNodeLimitItems"
                  (updateDSP)="onUpdateDSP($event)"
                  (duplicatedEndpoint)="duplicateListEndpoint($event)"
                  (deleteEndpoint)="deleteListEndpoint($event)"
                  (updateEndpointActiveStatus)="
                    onEndpointActiveStatusChange($event)
                  "
                ></app-list-endpoints>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </nz-table>
    </ng-container>
    <ng-template #noDataTable>
      <app-placeholder
        text="No Data Available"
        *ngIf="!dspSpinnerStatus"
        [marginTop]="placeholderMarginTop"
      ></app-placeholder>
    </ng-template>
  </div>
  <div class="main-table-endpoints" *ngIf="showEndpoint">
    <ng-container *ngIf="dataEndpoints.length > 0; else noDataTable">
      <nz-table
        [ngStyle]="{ height: tableHeight }"
        [nzScroll]="{ y: tableHeight }"
        [nzSize]="'small'"
        [nzFrontPagination]="false"
        (nzPageIndexChange)="onPageIndexChange($event, 'endpoints')"
        [nzPageSize]="paginationState.per_page"
        [nzPageIndex]="paginationState.current_page"
        [nzTotal]="paginationState.total"
        [nzData]="dataEndpoints"
        #wrapper
      >
        <thead>
          <tr>
            <th nzWidth="90px">OFF/ON</th>
            <th nzWidth="90px" (click)="sort('id')">
              ID
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortByDSP === 'id'"
              >
                <span
                  class="sort-icon sort-icon-{{
                    mainTableService.sortOrderDSP
                  }}"
                ></span>
              </span>
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortByDSP !== 'id'"
              >
                <span class="sort-icon sort-icon-normal"></span>
              </span>
            </th>
            <th nzWidth="230px" (click)="sort('name')">
              NAME
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortByDSP === 'name'"
              >
                <span
                  class="sort-icon sort-icon-{{
                    mainTableService.sortOrderDSP
                  }}"
                ></span>
              </span>
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortByDSP !== 'name'"
              >
                <span class="sort-icon sort-icon-normal"></span>
              </span>
            </th>
            <th nzWidth="90px" *ngIf="isOptionActive('type', type)">TYPE</th>
            <th nzWidth="200px" *ngIf="isOptionActive('formats', type)">
              AD FORMATS
            </th>
            <th
              nzWidth="140px"
              *ngIf="isOptionActive('limitQPS', type)"
              (click)="sort('limitQPS')"
            >
              LIMIT QPS
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortByDSP === 'limitQPS'"
              >
                <span
                  class="sort-icon sort-icon-{{
                    mainTableService.sortOrderDSP
                  }}"
                ></span>
              </span>
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortByDSP !== 'limitQPS'"
              >
                <span class="sort-icon sort-icon-normal"></span>
              </span>
            </th>
            <th
              nzWidth="140px"
              *ngIf="isOptionActive('realQPS', type)"
              (click)="sort('realQPS')"
            >
              REAL QPS
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortByDSP === 'realQPS'"
              >
                <span
                  class="sort-icon sort-icon-{{
                    mainTableService.sortOrderDSP
                  }}"
                ></span>
              </span>
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortByDSP !== 'realQPS'"
              >
                <span class="sort-icon sort-icon-normal"></span>
              </span>
            </th>
            <th
              nzWidth="110px"
              *ngIf="isOptionActive('bidQPS', type)"
              (click)="sort('bidQPS')"
            >
              BID QPS
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortByDSP === 'bidQPS'"
              >
                <span
                  class="sort-icon sort-icon-{{
                    mainTableService.sortOrderDSP
                  }}"
                ></span>
              </span>
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortByDSP !== 'bidQPS'"
              >
                <span class="sort-icon sort-icon-normal"></span>
              </span>
            </th>
            <th
              nzWidth="140px"
              *ngIf="isOptionActive('daylySpend', type)"
              (click)="sort('daylySpend')"
            >
              DAILY SPEND
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortByDSP === 'daylySpend'"
              >
                <span
                  class="sort-icon sort-icon-{{
                    mainTableService.sortOrderDSP
                  }}"
                ></span>
              </span>
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortByDSP !== 'daylySpend'"
              >
                <span class="sort-icon sort-icon-normal"></span>
              </span>
            </th>
            <th
              nzWidth="180px"
              *ngIf="isOptionActive('yesterdaySpend', type)"
              (click)="sort('yesterdaySpend')"
            >
              YESTERDAY SPEND
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortByDSP === 'yesterdaySpend'"
              >
                <span
                  class="sort-icon sort-icon-{{
                    mainTableService.sortOrderDSP
                  }}"
                ></span>
              </span>
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortByDSP !== 'yesterdaySpend'"
              >
                <span class="sort-icon sort-icon-normal"></span>
              </span>
            </th>
            <th
              nzWidth="180px"
              *ngIf="isOptionActive('dsp_ecpm', type)"
              (click)="sort('dsp_ecpm')"
            >
              Daily CPM
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortByDSP === 'dsp_ecpm'"
              >
                <span
                  class="sort-icon sort-icon-{{
                    mainTableService.sortOrderDSP
                  }}"
                ></span>
              </span>
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortByDSP !== 'dsp_ecpm'"
              >
                <span class="sort-icon sort-icon-normal"></span>
              </span>
            </th>
            <th
              nzWidth="180px"
              *ngIf="isOptionActive('dsp_rcpm', type)"
              (click)="sort('dsp_rcpm')"
            >
              DSP RCPM
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortByDSP === 'dsp_rcpm'"
              >
                <span
                  class="sort-icon sort-icon-{{
                    mainTableService.sortOrderDSP
                  }}"
                ></span>
              </span>
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortByDSP !== 'dsp_rcpm'"
              >
                <span class="sort-icon sort-icon-normal"></span>
              </span>
            </th>
            <th
              nzWidth="200px"
              *ngIf="isOptionActive('total_bid_rate', type)"
              (click)="sort('total_bid_rate')"
            >
              TOTAL BID RATE ,%
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortByDSP === 'total_bid_rate'"
              >
                <span
                  class="sort-icon sort-icon-{{
                    mainTableService.sortOrderDSP
                  }}"
                ></span>
              </span>
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortByDSP !== 'total_bid_rate'"
              >
                <span class="sort-icon sort-icon-normal"></span>
              </span>
            </th>
            <th
              nzWidth="130px"
              *ngIf="isOptionActive('win_rate', type)"
              (click)="sort('win_rate')"
            >
              WIN RATE
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortByDSP === 'win_rate'"
              >
                <span
                  class="sort-icon sort-icon-{{
                    mainTableService.sortOrderDSP
                  }}"
                ></span>
              </span>
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortByDSP !== 'win_rate'"
              >
                <span class="sort-icon sort-icon-normal"></span>
              </span>
            </th>
            <th
              nzWidth="110px"
              *ngIf="isOptionActive('fill_rate', type)"
              (click)="sort('fill_rate')"
            >
              FILL RATE
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortByDSP === 'fill_rate'"
              >
                <span
                  class="sort-icon sort-icon-{{
                    mainTableService.sortOrderDSP
                  }}"
                ></span>
              </span>
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortByDSP !== 'fill_rate'"
              >
                <span class="sort-icon sort-icon-normal"></span>
              </span>
            </th>
            <th nzWidth="170px" *ngIf="isOptionActive('spendLimit', type)">
              SPEND LIMIT
            </th>
            <th
              nzWidth="130px"
              *ngIf="isOptionActive('margin', type)"
              (click)="sort('margin')"
            >
              MARGIN
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortByDSP === 'margin'"
              >
                <span
                  class="sort-icon sort-icon-{{
                    mainTableService.sortOrderDSP
                  }}"
                ></span>
              </span>
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortByDSP !== 'margin'"
              >
                <span class="sort-icon sort-icon-normal"></span>
              </span>
            </th>
            <th nzWidth="110px" *ngIf="isOptionActive('region', type)">
              REGION
            </th>
            <th nzWidth="160px" *ngIf="isOptionActive('nurl', type)">NURL</th>
            <th nzWidth="130px" *ngIf="isOptionActive('email', type)">EMAIL</th>
            <th nzWidth="115px" *ngIf="isOptionActive('comments', type)">
              COMMENTS
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let child of dataEndpoints; let j = index"
            [ngClass]="{ 'is-test': child.isForTest === 1 }"
          >
            <td nzWidth="90px">
              <nz-switch
                [(ngModel)]="child.active"
                (ngModelChange)="
                  onEndpointTableActiveStatusChange($event, child.id, type)
                "
                [nzDisabled]="isDisabledSwitch(child)"
              ></nz-switch>
            </td>
            <td nzWidth="90px">{{ child.id }}</td>
            <td class="name">
              <button
                nz-button
                nzType="text"
                [disabled]="!filterLists.length"
                nz-tooltip
                nzTooltipTitle="{{ child.name }}"
                nzTooltipPlacement="top"
                class="end-name"
                (click)="openDspEditModal(child.id, child.companyId)"
                [name]="child.name"
              >
                {{ child.name | trunc: [20] }}
              </button>
            </td>
            <td nzWidth="90px" *ngIf="isOptionActive('type', type)">
              {{ connectionTypes[child.connectionType] }}
            </td>
            <td nzWidth="200px" *ngIf="isOptionActive('formats', type)">
              <img
                class="icon--formats"
                *ngIf="child.formats.banner"
                [src]="'/assets/img/formats/banner.svg'"
                alt=""
                nz-tooltip
                nzTooltipOverlayClassName="item-tooltip"
                nzTooltipTitle="Banner"
                nzTooltipPlacement="top"
              />
              <img
                class="icon--formats"
                *ngIf="child.formats.native"
                [src]="'/assets/img/formats/native.svg'"
                alt=""
                nz-tooltip
                nzTooltipOverlayClassName="item-tooltip"
                nzTooltipTitle="Native"
                nzTooltipPlacement="top"
              />
              <img
                class="icon--formats"
                *ngIf="child.formats.video"
                [src]="'/assets/img/formats/video.svg'"
                alt=""
                nz-tooltip
                nzTooltipOverlayClassName="item-tooltip"
                nzTooltipTitle="Video"
                nzTooltipPlacement="top"
              />
              <img
                class="icon--formats"
                *ngIf="child.formats.pop"
                [src]="'/assets/img/formats/pop.svg'"
                alt=""
                nz-tooltip
                nzTooltipOverlayClassName="item-tooltip"
                nzTooltipTitle="Pop"
                nzTooltipPlacement="top"
              />
              <img
                class="icon--formats"
                *ngIf="child.formats.push"
                [src]="'/assets/img/formats/push.svg'"
                alt=""
                nz-tooltip
                nzTooltipOverlayClassName="item-tooltip"
                nzTooltipTitle="Push"
                nzTooltipPlacement="top"
              />
              <img
                class="icon--formats"
                *ngIf="child.formats.audio"
                [src]="'/assets/img/formats/audio.svg'"
                alt=""
                nz-tooltip
                nzTooltipOverlayClassName="item-tooltip"
                nzTooltipTitle="Audio"
                nzTooltipPlacement="top"
              />
            </td>
            <td nzWidth="110px" *ngIf="isOptionActive('limitQPS', type)">
              {{ child.limitQPS }}
            </td>
            <td nzWidth="110px" *ngIf="isOptionActive('realQPS', type)">
              {{ child.realQPS }}
            </td>
            <td nzWidth="110px" *ngIf="isOptionActive('bidQPS', type)">
              {{ child.bidQPS }}
            </td>
            <td nzWidth="140px" *ngIf="isOptionActive('daylySpend', type)">
              {{
                currencyPipe.transform(
                  child.daylySpend,
                  "USD",
                  "symbol",
                  ".0-5"
                )
              }}
            </td>
            <td nzWidth="140px" *ngIf="isOptionActive('yesterdaySpend', type)">
              {{
                currencyPipe.transform(
                  child.yesterdaySpend,
                  "USD",
                  "symbol",
                  ".0-5"
                )
              }}
            </td>
            <td nzWidth="170px" *ngIf="isOptionActive('dsp_ecpm', type)">
              {{ child.dsp_ecpm }}
            </td>
            <td nzWidth="180px" *ngIf="isOptionActive('dsp_rcpm', type)">
              {{ child.dsp_rcpm }}
            </td>
            <td nzWidth="170px" *ngIf="isOptionActive('total_bid_rate', type)">
              {{ child.total_bid_rate }}
            </td>
            <td nzWidth="130px" *ngIf="isOptionActive('win_rate', type)">
              {{ child.win_rate }}
            </td>
            <td nzWidth="110px" *ngIf="isOptionActive('fill_rate', type)">
              {{ child.fill_rate }}
            </td>
            <td nzWidth="170px" *ngIf="isOptionActive('spendLimit', type)">
              {{ child.spendLimit }}
            </td>
            <td nzWidth="130px" *ngIf="isOptionActive('margin', type)">
              {{ getMargin(child) }}
            </td>
            <td nzWidth="110px" *ngIf="isOptionActive('region', type)">
              {{ child.region }}
            </td>
            <td nzWidth="160px" *ngIf="isOptionActive('nurl', type)">
              {{ child.nurl }}
            </td>
            <td
              *ngIf="isOptionActive('email', type)"
              nz-tooltip
              nzTooltipOverlayClassName="item-tooltip"
              [nzTooltipTitle]="child.email"
              nzTooltipPlacement="top"
            >
              {{ child.email | trunc: [10] }}
            </td>
            <td
              nzWidth="115px"
              *ngIf="isOptionActive('comments', type)"
              nz-tooltip
              nzTooltipOverlayClassName="item-tooltip"
              [nzTooltipTitle]="child.comments"
              nzTooltipPlacement="top"
            >
              {{ child.comments | trunc: [10] }}
            </td>
          </tr>
        </tbody>
      </nz-table>
    </ng-container>
    <ng-template #noDataTable>
      <app-placeholder
        text="No Data Available"
        *ngIf="!dspSpinnerStatus"
        [marginTop]="placeholderMarginTop"
      ></app-placeholder>
    </ng-template>
  </div>
</div>
